import { Injectable } from '@angular/core';
import { CodedEntity } from '@asm/features/sync/models/coded-entity.model';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';

/** Store: `categories` | keyPath: `code` */
@Injectable({ providedIn: 'root' })
export class CategoryRepository extends RepositoryBase<CodedEntity> {
  protected readonly KEY_PATH = 'categories';
}
